import {
  DatePicker as AntdDatePicker,
  DatePickerProps as AntdDatePickerProps,
} from 'antd';
import locale from 'antd/es/date-picker/locale/pt_BR';
import dayjs from 'dayjs';
import React from 'react';

type Props = {
  value?: string;
  onChange: (value: string | string[]) => void;
  picker?: AntdDatePickerProps['picker'];
  placeholder?: string;
} & Omit<AntdDatePickerProps, 'onChange' | 'value'>;

export const DatePicker: React.FC<Props> = ({
  value,
  onChange,
  picker,
  placeholder = 'Selecione',
  ...props
}) => {
  const handleChange: AntdDatePickerProps['onChange'] = (date, dateString) => {
    onChange?.(dateString);
  };

  return (
    <AntdDatePicker
      style={{ width: '100%' }}
      locale={locale}
      value={value ? dayjs(value) : undefined}
      placeholder={placeholder}
      onChange={handleChange}
      picker={picker}
      format='DD/MM/YYYY'
      {...props}
    />
  );
};
